var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusSquareOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2179_5399)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.16667 6.66667H5.33333V9.83333C5.33333 9.925 5.40833 10 5.5 10H6.5C6.59167 10 6.66667 9.925 6.66667 9.83333V6.66667H9.83333C9.925 6.66667 10 6.59167 10 6.5V5.5C10 5.40833 9.925 5.33333 9.83333 5.33333H6.66667V2.16667C6.66667 2.075 6.59167 2 6.5 2H5.5C5.40833 2 5.33333 2.075 5.33333 2.16667V5.33333H2.16667C2.075 5.33333 2 5.40833 2 5.5V6.5C2 6.59167 2.075 6.66667 2.16667 6.66667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.52 0H0.48C0.2145 0 0 0.2145 0 0.48V11.52C0 11.7855 0.2145 12 0.48 12H11.52C11.7855 12 12 11.7855 12 11.52V0.48C12 0.2145 11.7855 0 11.52 0ZM10.92 10.92H1.08V1.08H10.92V10.92Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2179_5399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSquareOutlined);
export default __webpack_public_path__ + "static/media/PlusSquareOutlined.1fe1930f659b60e852b93a446b72beeb.svg";
export { ForwardRef as ReactComponent };